import {
    Button,
} from 'antd';
import React, {FC, useState} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {TStateSetter} from 'shared/types/generics';
import {useAppDispatch} from 'store/config/hooks';
import {tableReportSliceActions} from 'store/slices/table-report-slice';

import {ControlRatiosTable} from '../tables/control-ratios-table';

const {
    updateComparisonOptions,
} = tableReportSliceActions;
interface IControlRatiosModalProps {
  docId: string;
  disabled: boolean;
  setShowCancelButton: TStateSetter<boolean>;
}

export const ControlRatiosModal: FC<IControlRatiosModalProps> = ({
    docId,
    disabled,
    setShowCancelButton,
}: IControlRatiosModalProps) => {
    const dispatch = useAppDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleSave = () => {
        dispatch(updateComparisonOptions({
            includeControlRatioBySettings: true,
            noFetchWithCustomCR: false,
            noFetchWithCR: true,
            noFetchWithComparison: true,
        }));

        setShowCancelButton(true);
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <ModalOpenerComponent
            isOpen={isModalOpen}
            setIsOpen={setIsModalOpen}
            handleCancel={handleCancel}
            handleSave={handleSave}
            modalProps={{
                title: 'Выбор документа для контрольных соотношений',
                forceRender: true,
                destroyOnClose: false,
                centered: true,
                width: '100%',
            }}
            component={(
                <Button
                    type="default"
                    disabled={disabled}
                >
                    Контрольные соотношения
                </Button>
            )}
        >
            {isModalOpen && (
                <ControlRatiosTable
                    docId={docId}
                />
            )}
        </ModalOpenerComponent>
    );
};
